module.exports = __webpack_public_path__ + "img/group-discount_catch.98599685.jpg";